// import React, { useEffect, useState } from "react";
// import { useSearchParams, Link } from "react-router-dom";
// import { verifyEmail } from "../../utils/api";

// export default function VerifyEmail() {
//   const [params] = useSearchParams();
//   const token = params.get("token");

//   const [message, setMessage] = useState("Verifying your email...");

//   useEffect(() => {
//     const process = async () => {
//       try {
//         await verifyEmail(token);
//         setMessage("Your email has been verified! You can now log in.");
//       } catch (error) {
//         setMessage("Invalid or expired verification token.");
//       }
//     };
//     process();
//   }, [token]);

//   return (
//     <div className="auth-container">
//       <h2>Email Verification</h2>
//       <p>{message}</p>

//       {message.includes("verified") && (
//         <Link to="/login">Go to Login</Link>
//       )}
//     </div>
//   );
// }

















import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { verifyEmail } from "../../utils/api";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();

  const [message, setMessage] = useState("Verifying your email...");

  useEffect(() => {
    const process = async () => {
      try {
        const res = await verifyEmail(token);
        const user = res.data.user;

        setMessage("Email verified! Redirecting...");

        // Delay for user feedback
        setTimeout(() => {
          if (!user) {
            navigate("/login");
            return;
          }

          // ⭐ Redirect Based on User Role ⭐
          switch (user.role) {
            case "OWNER":
              navigate("/owner/dashboard");
              break;

            case "SEEKER":
              navigate("/seeker/dashboard");
              break;

            case "ADMIN":
              navigate("/admin/dashboard");
              break;

            default:
              navigate("/dashboard");
          }
        }, 1200);

      } catch (error) {
        setMessage("Invalid or expired verification token.");
      }
    };

    process();
  }, [token, navigate]);

  return (
    <div className="auth-container">
      <h2>Email Verification</h2>
      <p>{message}</p>
    </div>
  );
}
